import pushPdtLogging from '@stencil/pdt-logging';
import pushGAEvents from '@stencil/flights-push-ga-events';

const pushAnalyticsData = (pdt_data, ga_data, omniture_data) => {
  //log pdt info
  if (pdt_data) {
    const {
      data,
      flightSearchData,
      staticInformation = {
        ri: {
          rid: ''
        }
      },
      pageUrl = '',
      experimentDetails = [],
      correlationIdForLogging = '',
      itineraryId = '',
      device_id
    } = pdt_data || {};

    //pass subtype key in meta_data for each pdt logging if not coming
    if (data.meta_data) {
      data.meta_data['subtype'] = `${data.meta_data['subtype'] || ''}`;
    }

    pushPdtLogging(
      data,
      flightSearchData,
      staticInformation,
      pageUrl,
      experimentDetails,
      correlationIdForLogging,
      device_id,
      null,
      itineraryId
    );
  }

  //log ga info
  if (ga_data) {
    const {
      event = '',
      eventName = '',
      eOption = '',
      eventCategory = '',
      eventAction = '',
      eventLabel = '',
      cdFields = {}
    } = ga_data || {};
    const newEvent = event || eventCategory;
    pushGAEvents(newEvent, eventName, eOption, eventCategory, eventAction, eventLabel, cdFields);
  }

  if (omniture_data) {
    if (typeof window === 'undefined') {
      return;
    }
    try {
      window.adobeDataLayer.push({ ...omniture_data });
    } catch (error) {
      console.error(error);
    }
  }
};

export default pushAnalyticsData;
